export enum OrganizationsExportColumns {
    activeAgbCode = 'activeAgbCode',
    activeCarepaths = 'activeCarepaths',
    activeGroups = 'activeGroups',
    alias = 'alias',
    bankAccountNumber = 'bankAccountNumber',
    bankAccountStatus = 'bankAccountStatus',
    bankAccountSubscriber = 'bankAccountSubscriber',
    canPerformGlaucoomExamination = 'canPerformGlaucoomExamination',
    cityAndZip = 'cityAndZip',
    description = 'description',
    emailAddressPayouts = 'emailAddressPayouts',
    emailAddressRequestInbox = 'emailAddressRequestInbox',
    endDate = 'endDate',
    kvkNumber = 'kvkNumber',
    name = 'name',
    nameStatutory = 'nameStatutory',
    organizationType = 'organizationType',
    phoneNumber = 'phoneNumber',
    previousNames = 'previousNames',
    relationNumber = 'relationNumber',
    startDate = 'startDate',
    state = 'state',
    status = 'status',
    txcsId = 'txcsId',
}
